import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';

const SubjectPage = ({ setTestno }) => {   // ← Receive setTestno from App
    const { subject } = useParams();
    const navigate = useNavigate();

    const safeSubject = subject?.toLowerCase().trim() || '';

    // Format subject name for display
    const subjectName = subject
        ? subject.toLowerCase() === "gk"
            ? "General Knowledge"
            : subject.charAt(0).toUpperCase() + subject.slice(1)
        : 'Subject';

    // Dynamic subject accent color
    const getSubjectColor = (sub) => {
        switch (sub) {
            case 'math': return '#3b82f6';
            case 'english': return '#8b5cf6';
            case 'gk': return '#10b981';
            case 'reasoning': return '#f59e0b';
            default: return '#3b82f6';
        }
    };

    const accentColor = getSubjectColor(safeSubject);

    // Hardcoded topics with IDs
    const getTopicsWithHardcodedIds = (sub) => {
        let topicsList = [];
        let topicsWithId = {};

        switch (sub) {
            case 'mathematics':
            case 'math':
                topicsList = [
                    "Journey 1",
                    "Journey 2",
                    "Journey 3",
                    "Journey 4",
                    "Journey 5",
                    "Journey 6",
                    "Journey 7",
                    "Journey 8",
                    "Journey 9",
                    "Journey 10",
                ];
                topicsWithId = {
                    "Journey 1": "mj1",
                    "Journey 2": "mj2",
                    "Journey 3": "mj3",
                    "Journey 4": "mj4",
                    "Journey 5": "mj5",
                    "Journey 6": "mj6",
                    "Journey 7": "mj7",
                    "Journey 8": "mj8",
                    "Journey 9": "mj9",
                    "Journey 10": "mj10",
                };
                break;

            case 'gk':
                topicsList = [
                    "Journey 1 (Exploring West Bengal)",
                    "Journey 2 (Indian Constitution)",
                    "Journey 3 (Digital Competence)",
                    "Journey 4 (Indian Economy)",
                    "Journey 5 (Life Science )",
                    "Journey 6 (Physical Science)",
                    "Journey 7 (Arts, Literature, Culture, Sports)",
                    "Journey 8 (Geography)",
                    "Journey 9 (History)",
                    "Journey 10 (Global Knowledge)"
                ];
                topicsWithId = {
                    "Journey 1 (Exploring West Bengal)": "gj1",
                    "Journey 2 (Indian Constitution)": "gj2",
                    "Journey 3 (Digital Competence)": "gj3",
                    "Journey 4 (Indian Economy)": "gj4",
                    "Journey 5 (Life Science )": "gj5",
                    "Journey 6 (Physical Science)": "gj6",
                    "Journey 7 (Arts, Literature, Culture, Sports)": "gj7",
                    "Journey 8 (Geography)": "gj8",
                    "Journey 9 (History)": "gj9",
                    "Journey 10 (Global Knowledge)": "gj10"
                };
                break;

            case 'reasoning':
                topicsList = [
                    "Journey 1",
                    "Journey 2",
                    "Journey 3",
                    "Journey 4",
                    "Journey 5",
                    "Journey 6",
                    "Journey 7",
                    "Journey 8",
                    "Journey 9",
                    "Journey 10"
                ];
                topicsWithId = {
                    "Journey 1": "rj1",
                    "Journey 2": "rj2",
                    "Journey 3": "rj3",
                    "Journey 4": "rj4",
                    "Journey 5": "rj5",
                    "Journey 6": "rj6",
                    "Journey 7": "rj7",
                    "Journey 8": "rj8",
                    "Journey 9": "rj9",
                    "Journey 10": "rj10"
                };
                break;

            case 'english':
                topicsList = [
                    "Journey 1 (Article, Prepositions, Phrase, Idioms, Voice Change, Narration, many more….)",
                    "Journey 2 (Article, Prepositions, Phrase, Idioms, Voice Change, Narration, many more….)",
                    "Journey 3 (Article, Prepositions, Phrase, Idioms, Voice Change, Narration, many more….)",
                    "Journey 4 (Article, Prepositions, Phrase, Idioms, Voice Change, Narration, many more….)",
                    "Journey 5 (Article, Prepositions, Phrase, Idioms, Voice Change, Narration, many more….)",
                    "Journey 6 (Article, Prepositions, Phrase, Idioms, Voice Change, Narration, many more….)",
                    "Journey 7 (Article, Prepositions, Phrase, Idioms, Voice Change, Narration, many more….)",
                    "Journey 8 (Article, Prepositions, Phrase, Idioms, Voice Change, Narration, many more….)",
                    "Journey 9 (Article, Prepositions, Phrase, Idioms, Voice Change, Narration, many more….)",
                    "Journey 10 (Article, Prepositions, Phrase, Idioms, Voice Change, Narration, many more….)"
                ];
                topicsWithId = {
                    "Journey 1 (Article, Prepositions, Phrase, Idioms, Voice Change, Narration, many more….)": "ej1",
                    "Journey 2 (Article, Prepositions, Phrase, Idioms, Voice Change, Narration, many more….)": "ej2",
                    "Journey 3 (Article, Prepositions, Phrase, Idioms, Voice Change, Narration, many more….)": "ej3",
                    "Journey 4 (Article, Prepositions, Phrase, Idioms, Voice Change, Narration, many more….)": "ej4",
                    "Journey 5 (Article, Prepositions, Phrase, Idioms, Voice Change, Narration, many more….)": "ej5",
                    "Journey 6 (Article, Prepositions, Phrase, Idioms, Voice Change, Narration, many more….)": "ej6",
                    "Journey 7 (Article, Prepositions, Phrase, Idioms, Voice Change, Narration, many more….)": "ej7",
                    "Journey 8 (Article, Prepositions, Phrase, Idioms, Voice Change, Narration, many more….)": "ej8",
                    "Journey 9 (Article, Prepositions, Phrase, Idioms, Voice Change, Narration, many more….)": "ej9",
                    "Journey 10 (Article, Prepositions, Phrase, Idioms, Voice Change, Narration, many more….)": "ej10"
                };
                break;

            default:
                topicsList = ["No topics available"];
                topicsWithId = { "No topics available": "0" };
        }
        return { topicsList, topicsWithId };
    };

    const { topicsList, topicsWithId } = getTopicsWithHardcodedIds(safeSubject);

    // Handle topic selection - Now properly sets testno in App.js
    const handleTopicClick = (topic) => {
        const selectedTestId = topicsWithId[topic];
        localStorage.setItem("testid", selectedTestId);  // Store selected topic for later use

        if (selectedTestId) {
            setTestno(selectedTestId);   // This must happen
            if (localStorage.getItem("admin") === "true") {
                navigate('/question')
            } else {
                navigate('/test');
            }
        } else {
            alert("Invalid topic");
        }
    };

    if (!subject) {
        return <div style={{ textAlign: 'center', padding: '100px' }}>No subject selected</div>;
    }

    return (
        <div style={{
            minHeight: '100vh',
            background: 'linear-gradient(to bottom right, #f9fafb, #f3f4f6)',
            paddingBottom: '80px'
        }}>
            {/* Header */}
            <div style={{
                backgroundColor: 'white',
                boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
                borderBottom: `3px solid ${accentColor}`,
                padding: '28px 24px',
                position: 'sticky',
                top: 0,
                zIndex: 10
            }}>
                <div style={{
                    maxWidth: '1400px',
                    margin: '0 auto',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '20px'
                }}>

                    <div>
                        <center>
                            <h1 style={{ fontSize: '1.8rem', fontWeight: '700', color: '#111827', margin: 0 }}>
                                {subjectName}
                            </h1>
                            <p style={{ margin: '0px 0 0 0', color: '#6b7280', fontSize: '1.05rem' }}>
                                Select a journey to begin the test
                            </p>
                        </center>
                    </div>
                </div>
            </div>

            {/* Topics List */}
            <div style={{
                maxWidth: '1400px',
                margin: '0 auto',
                padding: '48px 32px'
            }}>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
                    {topicsList.map((topic, index) => (
                        <div
                            key={index}
                            onClick={() => handleTopicClick(topic)}
                            style={{
                                backgroundColor: 'white',
                                padding: '22px 28px',
                                borderRadius: '20px',
                                border: `2.5px solid ${accentColor}`,
                                fontSize: '1.15rem',
                                color: '#1f2937',
                                fontWeight: '500',
                                cursor: 'pointer',
                                transition: 'all 0.25s ease',
                                boxShadow: '0 4px 12px -2px rgba(0, 0, 0, 0.06)',
                                minHeight: '68px',
                                display: 'flex',
                                alignItems: 'center',
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.transform = 'translateY(-3px)';
                                e.currentTarget.style.boxShadow = `0 12px 20px -4px ${accentColor}30`;
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.transform = 'translateY(0)';
                                e.currentTarget.style.boxShadow = '0 4px 12px -2px rgba(0, 0, 0, 0.06)';
                            }}
                        >
                            {topic.includes("(") ? (
                                <div
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        textAlign: "center",
                                        width: "100%",
                                        lineHeight: 1.3,
                                    }}
                                >
                                    <span>{topic.substring(0, topic.indexOf("(")).trim()}</span>
                                    <span
                                        style={{
                                            fontSize: "0.9rem",
                                            color: "#6b7280",
                                            fontWeight: 400,
                                        }}
                                    >
                                        {topic.substring(topic.indexOf("("))}
                                    </span>
                                </div>
                            ) : (
                                topic
                            )}
                        </div>
                    ))}
                </div>

                <div style={{
                    marginTop: '48px',
                    textAlign: 'center',
                    color: '#9ca3af',
                    fontSize: '0.95rem'
                }}>
                    {topicsList.length} topics available
                </div>
            </div><hr /><br />
            <center><img src="/back.png" onClick={() => navigate(-1)}
                alt="" style={{ width: '120px', height: '60px', cursor: 'pointer', bottom: '0' }} /></center>

        </div>
    );
};

export default SubjectPage;